import type { RequestFn } from '../http';

export interface OdometerReadingRef {
  month: string;
  odometerKm: number;
}

/** Stand der monatlichen Kilometerstand-Abfrage des angemeldeten Technikers. */
export interface OdometerStatus {
  /** Kalendermonat (Berliner Zeit) als YYYY-MM */
  month: string;
  /** Für diesen Monat fehlt noch ein Stand — dann fragt der Wizard. */
  needed: boolean;
  current: (OdometerReadingRef & { recordedAt: string }) | null;
  /** Letzter Stand aus einem früheren Monat, als Orientierung beim Eintragen. */
  last: OdometerReadingRef | null;
}

export function createOdometerApi(request: RequestFn) {
  return {
    async getOdometerStatus() {
      return request<OdometerStatus>('/odometer/status');
    },

    /** Trägt den Stand für den laufenden Monat ein; ein vorhandener wird nicht überschrieben. */
    async recordOdometer(body: { odometerKm: number; submissionId?: string }) {
      return request<{ reading: OdometerReadingRef; alreadyRecorded: boolean }>('/odometer', {
        method: 'POST',
        body: JSON.stringify(body),
      });
    },
  };
}
